import { genericPage, getMappingSeccio3CatInfo, getServerSidePropsHelper } from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { usePageEditMode } from 'hooks/usePageEditMode';

const CustomREDL = ({ props, router }) => {
    const genericPageProps = usePageEditMode(props, router);
    return genericPage(genericPageProps, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'tag']);
};

const Pagina = (props) => {
    const router = useRouter();
    const isCustomREDL = props?.slugs?.includes('custom_redl');

    if (isCustomREDL) {
        return <CustomREDL props={props} router={router} />;
    }

    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'tag']);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'tag'];

    const mapping = await getMappingSeccio3CatInfo(slug);

    if (!mapping) {
        return {
            notFound: true
        };
    }

    if (!__isEmpty(mapping.seccio) && mapping?.seccio?.lay) {
        if (mapping.seccio.lay === 'default') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio'];
        } else if (mapping.seccio.lay === '3catinfo_programa') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'programa'];
        } else if (mapping.seccio.lay === '3catinfo_custom_redl') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'custom_redl', slug];
        } else if (mapping.seccio.lay === '3catinfo_custom') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'custom', slug];
        } else if (mapping.seccio.lay === '3catinfo_metadatacustom') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'metadatacustom'];
        } else if (mapping.seccio.lay === '3catinfo_territorialcustom') {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'territorialcustom'];
        } else {
            path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'seccio', 'custom', mapping.seccio.lay];
        }
    }

    const options = {
        slugs: path,
        id: mapping?.seccio?.id || mapping?.uidTag,
        slug
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
